document.addEventListener("DOMContentLoaded", () => {
    const togglers = document.querySelectorAll(".navbar-toggler");

    togglers.forEach((toggler) => {
        toggler.addEventListener("click", function () {
            const container = this.closest(".header-container");
            if (!container) return;

            const openNav = container.querySelector(".nav-open");
            const closedNav = container.querySelector(".nav-closed");

            // Matches: var isOpen = $(this).closest(".nav-open").length;
            const isOpen = this.closest(".nav-open") !== null;

            if (isOpen) {
                if (openNav) openNav.style.display = "none";
                if (closedNav) closedNav.style.display = "block";

                // Find toggler within the container to update ARIA
                const containerToggler = container.querySelector(".navbar-toggler");
                if (containerToggler) containerToggler.setAttribute("aria-expanded", "false");
            } else {
                if (openNav) openNav.style.display = "block";
                if (closedNav) closedNav.style.display = "none";

                const containerToggler = container.querySelector(".navbar-toggler");
                if (containerToggler) containerToggler.setAttribute("aria-expanded", "true");

                window.scrollTo(0, 0);
                setWindowTop();
            }
        });
    });

    function setWindowTop() {
        const closedNavs = document.querySelectorAll("header .nav-closed");
        closedNavs.forEach((nav) => {
            nav.classList.add("fixed");
            nav.style.marginTop = "0";
            nav.classList.remove("fixed");
        });
    }

    function setWindowScroll() {
        const closedNavs = document.querySelectorAll("header .nav-closed");
        closedNavs.forEach((nav) => {
            nav.classList.add("fixed");
        });
    }

    window.addEventListener("scroll", () => {
        // Matches: var closedNav = $(".header-container").find(".nav-closed");
        const closedNav = document.querySelector(".header-container .nav-closed");

        // Matches: if (closedNav.is(":visible"))
        if (closedNav && !!(closedNav.offsetWidth || closedNav.offsetHeight || closedNav.getClientRects().length)) {
            if (window.pageYOffset > 0) {
                setWindowScroll();
            } else {
                setWindowTop();
            }
        }
    });
});
